import FightsManageApp from "./FightsManageApp.vue";
import { vueAppWithPinia } from "../Common/vueApp";

export default vueAppWithPinia(FightsManageApp);
